import { ServiceName } from "../constants";


export const getApiBaseEndPoint = (serviceName: string) => {
  const sessionConfig = localStorage.getItem("config");
  if (sessionConfig === null) {
    console.log("App settings (msal) are not loaded into the session store yet!");
    return "";
  }

  const appSettings = JSON.parse(sessionConfig);
  const protectedResources = appSettings?.protectedResources;
  return protectedResources?.[serviceName]?.baseEndPoint;
}
export const LookupServieURL = getApiBaseEndPoint(ServiceName.LOOKUPSERVICE.toString());
export const AppraisalReviewServiceURL = getApiBaseEndPoint(ServiceName.APPRAISALREVIEW.toString());
// export const TaskmgmtURL = "https://task-management-dev1-east-eks-lb.aws.tiaa-cref.org/api";
export const InvestmentServiceURL = getApiBaseEndPoint(ServiceName.INVESTMENTSERVICE.toString());
export const TaskmgmtServiceURL = getApiBaseEndPoint(ServiceName.TASKMANAGEMENTSERVICE.toString());
export const DocumentServiceURL = getApiBaseEndPoint(ServiceName.DOCUMENTSERVICE.toString());
export const GraphAPIURL = "https://graph.microsoft.com/v1.0/me?$select=mail,displayname,givenName,surname,userPrincipalName,usertype";

//export const baseUrl = "https://localhost:50297/api/";
